import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { merge, Observable, of } from 'rxjs'
import { CategoryModel } from '../models/category.model'
// import { AppConfig } from 'projects/jml-lib/src/lib/app-config';
import { switchMap, map, catchError, tap, filter, take } from 'rxjs/operators'
import { Setting } from '../models/setting.model'
import { AppConfigService } from '../../../app-config/app-config.service'
import { ActionsSubject, Store } from '@ngrx/store'
import { RootStoreState } from '../../../root-store/root-index'
import { ofType } from '@ngrx/effects'
import { SettingActions } from '../../../root-store/setting-store/setting-index'
import { UrlCollection } from '../../../url-collection'

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    private store$: Store<RootStoreState.State>,
    private actions$: ActionsSubject,
    private appConfig: AppConfigService
  ) {}

  getSystemSettings(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(UrlCollection.Settings.GET_SYSTEM_SETTINGS())
  }

  getUserSettings(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(UrlCollection.Settings.GET_USER_SETTINGS())
  }

  getSetting(name: string): Observable<Setting> {
    if (!name) return null

    const setting$ = merge(
      this.actions$.pipe(ofType(SettingActions.settingRetrieved)),
      this.actions$.pipe(ofType(SettingActions.settingRequestFailed))
    ).pipe(
      filter((action) => action.name === name),
      take(1),
      map((action) => action['setting'])
    )
    this.store$.dispatch(SettingActions.settingRequested({ name: name }))
    return setting$
  }

  getSettingUncached(name: string): Observable<Setting> {
    return this.appConfig.getBaseUrl$().pipe(
      take(1),
      switchMap(() => this.http.get<Setting>(UrlCollection.Settings.GET_SETTING(name)))
    )
  }

  private _setSetting(url: string, name: string, value: string) {
    return this.http.post(url, { name, value }).pipe(
      // todo: find better way to handle empty responses!
      map(() => true),
      catchError((err) => {
        console.error(`could not save setting '${name}' with value '${value}'. error: `, err)
        return of(false)
      })
    )
  }

  setSystemSetting(name: string, value: string): Observable<boolean> {
    return this._setSetting(UrlCollection.Settings.SET_SYSTEM_SETTING(), name, value)
  }

  setUserSetting(name: string, value: string): Observable<boolean> {
    return this._setSetting(UrlCollection.Settings.SET_USER_SETTING(), name, value)
  }

  ping(): Observable<any> {
    return this.http.get<any>(UrlCollection.Files.TEST_NEXTCLOUD_CONNECTION())
  }

  getMaxUpload(): Observable<number> {
    return this.getSetting('MAX_UPLOAD_SIZE_MB').pipe(map((result) => +result.value))
  }

  /** returns the idle time in minutes after which the user token expires. */
  getUserIdleSessionTimeoutInMinutes = (): Observable<number> =>
    this.getSetting('USER_IDLE_SESSION_TIMEOUT').pipe(
      tap((timeout) => console.log('reading USER_IDLE_SESSION_TIMEOUT', timeout)),
      map((timeout) => +timeout.value)
    )
}
